import React from 'react';
import ContactFormOverview from '../compositions/ContactFormOverview';

const ContactFormOverviewPage: React.FC = () => {
    return <ContactFormOverview />;
};

export default ContactFormOverviewPage; 